enum RecapAssetShareVariant {
  Asset = 'Asset',
  Url = 'Url'
}
export default RecapAssetShareVariant
